import React, {PureComponent} from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"

import {MarginLeftPara} from "../shared"

const StyledLink = styled(Link)`
  &:hover, &:focus {
    text-decoration: none;
  }
`

class HelpEmail extends PureComponent<InjectIntl> {
  render() {
    const {formatMessage} = this.props
    return (
      <StyledLink uppercase={false} href={formatMessage({id: "medical.landing.contactCard.email.mailto"})}>
        <MarginLeftPara blue large>
          <FormattedMessage id="medical.landing.contactCard.email.text" />
        </MarginLeftPara>
      </StyledLink>
    )
  }
}

export default injectIntl(HelpEmail)
